export default "__VITE_ASSET__dd58dd7d__"